import { createAction } from '@reduxjs/toolkit';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';

export interface LoginRequestPayload {
    username: string;
    password: string;
}

export interface LoginSuccessPayload {
    access_token: string;
    user_id: number;
    email: string;
    role: string;
    avatar_url: string | null;
    full_name: string | null;
    /** Login identifier from backend (normal + SSO token exchange). */
    username: string | null;
    k12_username?: string | null;
    session_key?: string | null;
    /** Quyền theo ma trận phân quyền; login SSO chưa có, FE tự gọi /api/rbac/me/. */
    rbac?: RbacPayload | null;
}

/** Field "rbac" của response login và của /api/rbac/me/ (BE: build_login_rbac). */
export interface RbacPayload {
    role_type: string | null;
    is_super_admin: boolean;
    /** off: BE chưa kiểm tra quyền | log: chỉ ghi log | enforce: chặn thật */
    mode: 'off' | 'log' | 'enforce';
    /** codename quyền Django, vd 'view_submodules' */
    permissions: string[];
}

export interface LoginFailurePayload {
    error: string;
}

export const FETCH_MY_PERMISSIONS = 'FETCH_MY_PERMISSIONS';

export const loginRequest = createAction<LoginRequestPayload>(LOGIN_REQUEST);
export const loginSuccess = createAction<LoginSuccessPayload>(LOGIN_SUCCESS);
export const loginFailure = createAction<LoginFailurePayload>(LOGIN_FAILURE);
export const logout = createAction(LOGOUT);
export const fetchMyPermissions = createAction(FETCH_MY_PERMISSIONS);
